import { render, staticRenderFns } from "./CantonAddView.vue?vue&type=template&id=2e5388be"
import script from "./CantonAddView.vue?vue&type=script&lang=js"
export * from "./CantonAddView.vue?vue&type=script&lang=js"
import style0 from "./CantonAddView.vue?vue&type=style&index=0&id=2e5388be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports